import {
  PayeeRequirement,
  PayeeRequirementExpirationStatus
} from "@wingspanhq/wingspan-api-sdk";

export const selectorExpiredRequirements = (requirements: PayeeRequirement[]) =>
  requirements.filter(
    e => e.expirationStatus === PayeeRequirementExpirationStatus.EXPIRED
  );
